module.exports = __webpack_public_path__ + "static/3-before.52ca5f2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/full-size/3-before.jpg
// module id = 438
// module chunks = 221374088121123